import ConvocatoriaCityFilter from '@/containers/home/convocatoria/cityFilter'
import { ConvocatoriasState } from '@/state'

export default function ImportDetails() {
  return (
    <div className='import-details'>
      <div className='details-item'>
        <div className='detail-label'>CONVOCATORIA</div>
        <div className='detail-value'>
          {ConvocatoriasState.currentConvocatoria.value.name}
        </div>
      </div>
      <div className='details-item'>
        <div className='detail-label'>MUNICIPIO</div>
        <ConvocatoriaCityFilter />
      </div>
    </div>
  )
}
